/** Funnel-Stufen, ab denen der Kunde ins Dashboard gehoert statt ins Onboarding.
 *  Wird von Dashboard.tsx als Whitelist fuers eigene Gate mitbenutzt — beide
 *  Bedingungen muessen dieselbe Menge kennen, sonst entsteht entweder eine
 *  Schleife oder eine veraltete Seite (Testlauf 26.08.2026).
 *
 *  Eigene Datei (Welle 4, 09/2026): Das Dashboard importierte dafuer die ganze
 *  Onboarding-Seite samt Vertragstexten und Bildkompression (~180 KB roh). */
export const NACH_DEM_ONBOARDING = ["probetag_gebucht", "probetag_absolviert", "aktiv"];
